import ApiTypes from "../types/apiTypes";

export interface ApiState {
  pingResult: any | null;
  pingLoading: boolean;
  pingError: string | null;
  userInfo: any | null;
  userInfoLoading: boolean;
  userInfoError: string | null;
  employeeSearchResults: any[];
  employeeSearchLoading: boolean;
  employeeSearchError: string | null;
}

const initialState: ApiState = {
  pingResult: null,
  pingLoading: false,
  pingError: null,
  userInfo: null,
  userInfoLoading: false,
  userInfoError: null,
  employeeSearchResults: [],
  employeeSearchLoading: false,
  employeeSearchError: null,
};

const apiReducer = (state = initialState, action: any): ApiState => {
  switch (action.type) {
    // Ping
    case ApiTypes.PING_REQUEST:
      return {
        ...state,
        pingLoading: true,
        pingError: null,
      };
    case ApiTypes.PING_SUCCESS:
      return {
        ...state,
        pingLoading: false,
        pingResult: action.payload,
      };
    case ApiTypes.PING_FAILURE:
      return {
        ...state,
        pingLoading: false,
        pingError: action.payload?.message || "Ping failed",
      };

    // User Info
    case ApiTypes.GET_USER_INFO:
      return {
        ...state,
        userInfoLoading: true,
        userInfoError: null,
      };
    case ApiTypes.GET_USER_INFO_SUCCESS:
      return {
        ...state,
        userInfoLoading: false,
        userInfo: action.payload,
      };
    case ApiTypes.GET_USER_INFO_FAILURE:
      return {
        ...state,
        userInfoLoading: false,
        userInfoError: action.payload?.message || "Failed to get user info",
      };

    // Employee Search
    case ApiTypes.SEARCH_EMPLOYEE_REQUEST:
      return { ...state, employeeSearchLoading: true, employeeSearchError: null };
    case ApiTypes.SEARCH_EMPLOYEE_SUCCESS:
      return {
        ...state,
        employeeSearchLoading: false,
        employeeSearchResults: action.payload?.data || action.payload || [],
      };
    case ApiTypes.SEARCH_EMPLOYEE_FAILURE:
      return {
        ...state,
        employeeSearchLoading: false,
        employeeSearchResults: [],
        employeeSearchError: action.payload?.message || "Failed to search employees",
      };

    default:
      return state;
  }
};

export default apiReducer;
